<template>
  <div class="start flex-grow-1 flex-fill">
    <div class="wrapper-auth-sso h-100">
      <h4 class="title-auth-sso">BugHunt</h4>
      <div class="box-auth-sso mt-3">
        <h5>{{ $ml.get("authenticationRedirect") }}</h5>
        <p>{{ $ml.get("redirectPleaseWait") }} <Spinner /></p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
export default {
  components: {},
  page: {
    title: "AuthSSO",
    meta: [{ name: "description" }],
  },
  data() {
    return {
      token: "",
    };
  },
  validations: {
    user: { required },
    password: { required },
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  mounted() {
    const url = this.$route.fullPath;
    this.token = url.match(/id_token=([^&]*)/)[1];
    this.sendToken();
  },
  methods: {
    ...mapActions([
      "setUser",
      "resetUser",
      "setAmountPrograms",
      "setCanAccessExtApi",
      "setTermsUseConduct",
      "setAmountPentests"
    ]),
    async sendToken() {
      try {
        const { data, status } = await axios.get(
          this.$apiUrlAuth + `sso/validate-token`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          }
        );
        if (status == 200) {
          const { access_token } = data;

          var decodedStr = JSON.parse(atob(access_token.split(".")[1]));

          this.setTermsUseConduct(decodedStr.termsUseConduct);

          await this.getDados(access_token, decodedStr.roles[0]);
        }
      } catch (error) {
        console.log(error.response.data);
        const { email } = error.response.data.data;
        if (error.response.data.message === "Usuário não cadastrado") {
          this.$router.push({
            name: "RegisterCompany",
            query: {
              register: "register-account",
              token: this.token,
              email: email,
            },
          });
          return;
        }
        Swal.fire({
          icon: "error",
          title: self.$ml.get("notAuthorized"),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        this.$router.push("/login");
      }
    },
    async getDados(token, type) {
      var self = this;

      axios
        .get(this.$store.getters["getApiUrl"] + `account/my`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(async (response) => {
          self.setUser({
            token: token,
            type: type,
            account_avatar: response.data.account_avatar,
            company_avatar: response.data?.company_avatar,
            name: response.data.name,
            email: response.data.email,
            companyName: response.data?.companyName,
            username: response.data?.username,
            verified: response.data?.verified,
            paypal_account: response.data?.paypal_account,
            amount_of_reports: response.data?.amount_of_reports,
            score: response.data?.score,
            role: response.data?.role,
            plan: response.data.plan,
            company_createdAt: response.data.company_createdAt,
            account_createdAt: response.data.account_createdAt,
            two_factor_auth_login: response.data.two_factor_auth_login,
            email_code_required: response.data.email_code_required,
            lockerPassword: response.data.lockerPassword,
          });
          if (type == "company") {
            self.setAmountPrograms(response.data.amount_of_programs);
            self.setAmountPentests(response.data.amount_of_pentests);
            self.setCanAccessExtApi(response.data.plan.can_access_ext_api);

            self.setUser({
              two_factor_auth_required:
                response.data.settings.two_factor_auth_required,
              currency: response.data.settings.currency,
              lockerSettings: response.data.lockerSettings,
            });
            const two_factor_auth_required =
              response.data.settings.two_factor_auth_required;
            const two_factor_auth_login = response.data.two_factor_auth_login;
            if (two_factor_auth_required && !two_factor_auth_login) {
              this.$router.push({
                name: "account",
                params: { authentication: "authentication" },
              });
              return;
            }
          }
          if (this.$store.getters["getRouteTo"]) {
            let to = this.$store.getters["getRouteTo"];
            this.$store.dispatch("setRouteTo", "");
            window.location.replace(to);
            return;
          }

          window.location.replace("/dashboard");
        });
    },
  },
};
</script>
<style>
.wrapper-auth-sso {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #ffff;
}
.title-auth-sso {
  font-size: 30px;
  font-weight: 300;
}
.box-auth-sso {
  background: #5d006d;
  padding: 20px 50px;
  border-radius: 6px;
  box-shadow: 0px 0px 7px 2px #00000052;
}
.box-auth-sso > h5 {
  font-size: 18px;
  font-weight: 400;
}
.box-auth-sso > p {
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
